import api from "@/plugins/axios";

const UtilsAPI = {
  async add_utm_params(url: string, ad_unit_id?: string): Promise<string> {
    console.log({
      url: url,
      ad_unit_id: ad_unit_id,
    });

    return api.post("/utils/add_utm_params", {
      url: url,
      ad_unit_id: ad_unit_id,
    });
  },
  async generate_api_key(): Promise<{ apiKey: string }> {
    return api.post("/utils/generate_api_key");
  },
  async shorten_url(payload: {
    url: string;
  }): Promise<{ url: string; shortenUrl: string }> {
    return api.post("/utils/shorten_url", payload);
  },
  async get_remote_content(url: string): Promise<any> {
    return api.get(url);
  },
};

export default UtilsAPI;
